import { Grid, TextField } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const RequestBody = ({ handleContextMenu }) => {
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  const bodyRef = useRef();
   const [selectedText, setSelectedText] = useState('');
  const enableTabKeyInBody = (e) => {
    const { value } = e.target;

    if (e.key === 'Tab') {
      e.preventDefault();

      const cursorPosition = e.target.selectionStart;
      const cursorEndPosition = e.target.selectionEnd;
      const tab = '\t';

      e.target.value = value.substring(0, cursorPosition) + tab + value.substring(cursorEndPosition);

      // if you modify the value programmatically, the cursor is moved
      // to the end of the value, we need to reset it to the correct
      // position again
      e.target.selectionStart = cursorPosition + 1;
      e.target.selectionEnd = cursorPosition + 1;
    }
  };
  const handleMouseUp = () => {
    // console.log(`Selected text: ${window.getSelection().toString()}`);
    if (window) {
      setSelectedText(window.getSelection()?.toString());
    }
  };
  
  return (
    <Grid container spacing={1} direction="row">
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          minRows={10}
          maxRows={100}
          onKeyDown={enableTabKeyInBody}
          inputRef={bodyRef}
          onMouseUp={handleMouseUp}
          {...register('aiEngineConfig.inferenceOptions.jsonBodyTemplate')}
          defaultValue={getValues('aiEngineConfig.inferenceOptions.jsonBodyTemplate') ?? ''}
          onContextMenu={(e) =>
            handleContextMenu(e, { input: 'body', fieldName: 'aiEngineConfig.inferenceOptions.jsonBodyTemplate', selectedText:selectedText }, bodyRef)
          }
        />
      </Grid>
    </Grid>
  );
};

export default RequestBody;
